// import React, { useState, useMemo, useEffect, useRef } from "react";
// import "./style.css";
// import VillaCard from "../../villacard/VillaCard";
// import { assets } from "../../../assets/assets";
// import Button from "../../button/button"; // ← تأكدي إنك مستوردة الـ Button

// const ITEMS_PER_PAGE = 10;

// function FilterMasterVillas({
//   closeOverlay,
//   units,
//   filterSelection,
//   setProgressVilla,
//   setSpinVilla,
// }) {

//   const [closing, setClosing] = useState(false);
//   const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE); // ← state جديد للـ pagination

//   const panelRef = useRef(null);

//   const filteredUnits = useMemo(() => {
//     if (!units || !filterSelection) return units || [];

//     if (filterSelection.mode === "type" && filterSelection.data?.length > 0) {
//       return units.filter(
//         (unit) =>
//           unit.type?.name && filterSelection.data.includes(unit.type.name)
//       );
//     }

//     if (filterSelection.mode === "availability" && filterSelection.data?.length > 0) {
//       return units.filter((unit) =>
//         filterSelection.data.includes(unit.availability?.id)
//       );
//     }

//     if (filterSelection.mode === "construction" && filterSelection.data?.length > 0) {
//       return units.filter((unit) =>
//         filterSelection.data.includes(unit.progress?.status)
//       );
//     }

//     return units;
//   }, [units, filterSelection]);

//   // الـ units اللي هتظهر حاليًا (حسب visibleCount)
//   const visibleUnits = filteredUnits.slice(0, visibleCount);

//   const startClose = () => setClosing(true);

//   useEffect(() => {
//     if (closing) {
//       setTimeout(() => closeOverlay(), 500);
//     }
//   }, [closing, closeOverlay]);

//   return (
//     <div
//       className={`overlay-container filter-overlay ${closing ? "fadeOut" : "fadeIn"}`}
//       onClick={startClose}
//     >
//       <div
//         ref={panelRef}
//         className={`overlay-panel ${closing ? "slideOut" : "slideIn"}`}
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="overlay-header">
//           <button className="close-btn-" onClick={startClose}>
//             <img src={assets.close_circle} alt="Close" />
//           </button>
//           <p className="m-0 p-0">
//             Showed {visibleUnits.length} of {filteredUnits.length}
//           </p>
//         </div>

//         <div className="overlay-content">
//           <div className="row">
//             {visibleUnits.map((unit) => (
//               <div key={unit.id} className="col-12 mb-3">
//                 <VillaCard
//                   villa={unit}
//                   page="master-plan"
//                   onShowProgress={setProgressVilla}
//                   onOpenModal={() => setSpinVilla(unit)}
//                 />
//               </div>
//             ))}
//             {visibleCount < filteredUnits.length && filteredUnits.length > ITEMS_PER_PAGE && (
//               <div className="col-12 text-center mb-4">
//                 <Button
//                   text="Show More"
//                   className="main-btn"
//                   onClick={() =>
//                     setVisibleCount((prev) =>
//                       Math.min(prev + ITEMS_PER_PAGE, filteredUnits.length)
//                     )
//                   }
//                 />
//               </div>
//             )}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default FilterMasterVillas;

import React, { useState, useEffect, useRef } from "react";
import "./style.css";
import VillaCard from "../../villacard/VillaCard";
import { assets } from "../../../assets/assets";
import Button from "../../button/button";
const ITEMS_PER_PAGE = 10;

function FilterMasterVillas({
  closeOverlay,
  units,
  setProgressVilla,
  setSpinVilla,
}) {
  const [closing, setClosing] = useState(false);
  const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);
  const panelRef = useRef(null);
  const visibleUnits = units.slice(0, visibleCount);
  const startClose = () => setClosing(true);
  useEffect(() => {
    if (closing) {
      setTimeout(() => closeOverlay(), 500);
    }
  }, [closing, closeOverlay]);

  return (
    <div
      className={`overlay-container filter-overlay col-10 col-md-5 ${
        closing ? "fadeOut" : "fadeIn"
      }`}
      onClick={startClose}
    >
      <div
        ref={panelRef}
        className={`overlay-panel ${closing ? "slideOut" : "slideIn"}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="overlay-header">
          <button className="close-btn-" onClick={startClose}>
            <img src={assets.close_circle} alt="Close" />
          </button>
          <p className="m-0 p-0">
            Showed {visibleUnits.length} of {units.length}
          </p>
        </div>

        <div className="overlay-content">
          <div className="row">
            {visibleUnits.map((unit) => (
              <div key={unit.id} className="col-12 mb-3">
                <VillaCard
                  villa={unit}
                  page="master-plan"
                  onShowProgress={setProgressVilla}
                  onOpenModal={() => setSpinVilla(unit)}
                />
              </div>
            ))}

            {visibleCount < units.length && units.length > ITEMS_PER_PAGE && (
              <div className="col-12 text-center mb-4">
                <Button
                  text="Show More"
                  className="main-btn"
                  onClick={() =>
                    setVisibleCount((prev) =>
                      Math.min(prev + ITEMS_PER_PAGE, units.length)
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FilterMasterVillas;
